import 'ui-core/widgets/raa/js/raa';
import 'ui-core/widgets/raa/js/registration';
import '../../../components/raa/js/raa';
(function () {
    // Photoheme has an additional popup for the loging and signup where both forms are placed in tabs.
    // UX3 level js handler for that is unapplicable because of different markup and classes usage.
    // The script below provides for that need.
    $(document).ready(function () {
        // enable sumbit btn for access token widget
        var signupForm = $(
            '.login-form-container form[action="/action/registration"], .login-form-container .registration-form'
        ); // form selection by action has to be removed once the second selector will be created
        signupForm.find('input[type=submit]').attr('disabled', 'disabled');

        signupForm.find('input[type=email]').on('keyup input change', function () {
            var submitButton = signupForm.find('input[type=submit]');
            !$(this).val().length ? submitButton.attr('disabled', 'disabled') : submitButton.removeAttr('disabled');
        });
    });
})();
